var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"halloweenBox"},[_c('div',{staticClass:"alFitrBox langEn",class:_vm.lang == 'ar' ? 'langAr':''},[_c('div',{staticClass:"gift1"}),_c('div',{staticClass:"gift2"}),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gift34Box"},[_c('div',{staticClass:"gift3"}),_c('div',{staticClass:"gift4"})])
}]

export { render, staticRenderFns }